<div class="contacto-flotante" (click)="toggleForm()" [class.desktop]="!isMobile" [class.mobile]="isMobile" *ngIf="isVisible"> 
    <img src="assets/image/ico-operador.png" alt="Operador" class="contact-icon"/>
    
    <button class="close-icon-button" (click)="hideIcon($event)">
        <i class="fas fa-times"></i>
    </button>
    
    <span class="message" style="background-color: white;" *ngIf="!isMobile">¿No encuentras lo que buscas? </span>
</div>

<div *ngIf="isFormVisible" class="form-container">
    No encuentras lo que buscas
    Déjanos tu mensaje y tu correo. Te responderemos pronto.
    <br> <br>

<form (ngSubmit)="sendMessage(contactForm.value)" #contactForm="ngForm" class="form-contacto">
    <div class="form-group">
        <label for="message">Mensaje:</label>
        <textarea id="message" name="message" placeholder="Ingrese mensaje" ngModel required></textarea>
    </div>

    <div class="form-group" >
        <label for="email" >Correo electrónico:</label>
        <input id="email" name="email" placeholder="Ingrese correo" type="email" ngModel required />
    </div>

    <button type="submit" class="btn-enviar">Enviar</button>

    <i class="fas fa-times close-icon" (click)="toggleForm()"></i>
</form>


    <button class="whatsapp-button" (click)="openWhatsApp()">
        <i class="fab fa-whatsapp" style="margin-right:10px;"></i> Quiero conversar con alguien
    </button>
</div>
